shadow$provide[411] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 getMask(vec4 xyzw) {
  return vec4(1.0);
}`;

};